import { render } from "./CreateBranche.vue?vue&type=template&id=a6c30882&scoped=true"
import script from "./CreateBranche.vue?vue&type=script&lang=js"
export * from "./CreateBranche.vue?vue&type=script&lang=js"

import "./CreateBranche.vue?vue&type=style&index=0&id=a6c30882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c30882"]])

export default __exports__